import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ProductOverview from "./sections/ProductOverview";
import ProductFeatures from "./sections/ProductFeatures";
import ProductsGrid from "./sections/ProductsGrid";
import WarrantyInquiry from "./sections/WarrantyInquiry";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBanner />
      <ProductOverview />
      <ProductFeatures />
      <ProductsGrid />
      <WarrantyInquiry />
      <Footer />
    </div>;
}